import React from "react"
import CAccountBenefits from "../elements/c_account_benefits"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbButton from "../ui-kit/dfb_button"
import content from "../../content"
import { useRegistrationUrlForPage } from "../../hooks/headerLinks/registration"

const CSignupCard = () => {
  const baseClass = "c-SignupCard"
  const signupUrl = useRegistrationUrlForPage(window.location.href)
  return (
    <div className={baseClass}>
      <DfbHeadline
        headline={content.signupCard.headline}
        headline_level="h3"
        add_class={`${baseClass}-headline`}
      />
      <DfbParagraph text={content.signupCard.paragraph} add_class={`${baseClass}-paragraph`} />
      <CAccountBenefits add_class="u-Theme-dark" />
      <DfbButton
        tagName="a"
        link={signupUrl}
        text={content.signupCard.button}
        add_class={`${baseClass}-button u-Theme-dark`} />
    </div>
  )
}

export default CSignupCard
